import { render, staticRenderFns } from "./isupPersonFaceList.vue?vue&type=template&id=6222c4a1&scoped=true"
import script from "./isupPersonFaceList.vue?vue&type=script&lang=js"
export * from "./isupPersonFaceList.vue?vue&type=script&lang=js"
import style0 from "./isupPersonFaceList.vue?vue&type=style&index=0&id=6222c4a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222c4a1",
  null
  
)

export default component.exports